import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const OrderImportTime = {
  id: 'orderImportTime',
  displayName: <FormattedMessage {...messages.orderImportTime} />,
  type: OptionFormTypes.TYPE_DATE_COMPARISON,
  filterValue: 'OrderImportTime',

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_DATE_COMPARISON, criteriaInformations);
  },
};
